import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import sensAI_vault_template from "../components/templates/sensAI_vault_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;

let imageDescriptionEditor;
let imageCaptionEditor;
let galleryDescriptionEditor;
let bulkImageDescriptionEditor;
let bulkImageCaptionEditor;
let tagPickerSpecAreaEditor;

export default class sensai_vault extends vnModule_knockoutJS {
    protected sensaiVaultTemplate: sensAI_vault_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected tagXHRHdl: XMLHttpRequestHandler;
    protected tagSearchXHRHdl: XMLHttpRequestHandler;
    protected imageXHRHdl: XMLHttpRequestHandler;
    protected eventSource: EventSource;
    protected controller = new AbortController();
    protected idConnection = null;

    protected getModuleName(): string {
        return "sensai_vault";
    }
    public buildContent(): Array<Element> {
        this.sensaiVaultTemplate = new sensAI_vault_template('sensAI_vault', this.viewModel, this)
        return [this.sensaiVaultTemplate.build()]
    }

    public fillPage() {
    }

    private checkAccessibility() {
        this.loadingIn(this.sensaiVaultTemplate.builtTemplate);
        let formReq_url: string = "/api/sensAI-vault/sensai-vault-chat/check-access/";

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, [], this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        XHRHdl.onReadyStateFunction = this.onCheckAccessibility;
        XHRHdl.execute();
    }

    private onCheckAccessibility(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                if (req.request.status === 200) {

                }
            })
            obj.loadingOut(obj.sensaiVaultTemplate.builtTemplate);
        }
    }

    public initiateSensaiChat(userQuery, isQuickPrompt = false) {

        this.loadingIn(document.getElementById("user-query-container"));
        let articleText = '';

        let sessionId = this.sensaiVaultTemplate.getTemplateViewModel().sessionId();
        // Close any existing EventSource connection
        if (this.eventSource) {
            this.eventSource.close();
        }

        this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(true);
        this.sensaiVaultTemplate.getTemplateViewModel().dataQuery("");
        this.sensaiVaultTemplate.getTemplateViewModel().dataQueryResponse("");

        this.controller = new AbortController();
        const signal = this.controller.signal;

        fetch('/api/sensAI-vault/save-chat-session/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ articleText: articleText, sessionId: sessionId, chatHistory: this.sensaiVaultTemplate.getTemplateViewModel().chatHistory() }),
            signal: signal
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        }).then(data => {
            let sessionId = data.sessionId;
            this.sensaiVaultTemplate.getTemplateViewModel().sessionId(sessionId);
            userQuery = encodeURIComponent(userQuery);
            let formReq_url = `/api/sensAI-vault/sensai-vault-chat/?userQuery=${userQuery}&isQuickPrompt=${isQuickPrompt}`;
            this.eventSource = new EventSource(formReq_url);
            this.eventSource.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    //console.log("Streaming response:", data);

                    if (data.response && data.response.includes("idConnection")) {
                        const key = "idConnection:";
                        const startIndex = data.response.indexOf(key) + key.length;
                        const rest = data.response.substring(startIndex).trim();
                        const idConnection = rest.split(" ")[0]; // In case more text follows
                        this.idConnection = idConnection;
                    }else if(data.response && data.response.includes("<table")){
                        this.sensaiVaultTemplate.setQueryDataFormatted(data.response);
                    }else if(data.response && data.response.includes('[{"')){
                        this.sensaiVaultTemplate.setQueryData(JSON.parse(data.response));
                    }else if(data.response){
                        this.sensaiVaultTemplate.addToChatHistory(data.response, "system");
                    }

                    if (data === "[DONE]") {
                        console.log("Streaming finished.");
                        this.eventSource.close();
                        this.loadingOut(document.getElementById("user-query-container"));
                    }
                } catch (e) {
                    console.error("Error parsing SSE stream:", e);
                }
            };

            this.eventSource.addEventListener('close', (event) => {
                console.log("Streaming finished gracefully via custom close event.");
                this.eventSource.close();
                this.loadingOut(document.getElementById("user-query-container"));
                this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);
            });


            this.eventSource.onerror = (error) => {
                console.error("EventSource error:", error);
                this.eventSource.close();
                this.loadingOut(document.getElementById("user-query-container"));
                this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);
            };
        })
    }

    public analyzeData(dataQuery) {

        this.loadingIn(document.getElementById("db-query-container"));

        // Close any existing EventSource connection
        if (this.eventSource) {
            this.eventSource.close();
        }

        this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(true);

        let data = this.sensaiVaultTemplate.getTemplateViewModel().queryData();

        this.controller = new AbortController();
        const signal = this.controller.signal;

        fetch(`/api/sensAI-vault/analyze-db-query/?dataQuery=${dataQuery}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ dataQuery: dataQuery, queryData: data }),
            signal: signal
        }).then(response => {
            if (!response.ok) {
                //throw new Error('Network response was not ok');
            }
            this.loadingOut(document.getElementById("db-query-container"));
            this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);

            return response.json();
        }).then(data => {

            this.sensaiVaultTemplate.setDataQueryResponse(data.result);
            this.loadingOut(document.getElementById("db-query-container"));
            this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);
        })
    }

    public cancelRequest(){
        this.eventSource.close();
        this.loadingOut(document.getElementById("user-query-container"));
        this.sensaiVaultTemplate.getTemplateViewModel().isChatDisabled(false);

        if(this.idConnection){
            fetch('/api/sensAI-vault/kill-db-connection/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idConnection: this.idConnection }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
                this.idConnection = null;
            }).then(data => {
                console.log(data);
                this.idConnection = null;
            });
        }
    }

    protected bytesToSize(bytes) {
        var sizes = ["KB", "MB", "GB", "TB"];
        if (bytes == 0) return "n/a";
        var i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + " " + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    }

}


// WEBPACK FOOTER //
// ./js/modules/sensAI_vault.ts